// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriptionV2NdcGetByCodeCodeGetByCodeResponse {
    static getAttributeTypeMap() {
        return PrescriptionV2NdcGetByCodeCodeGetByCodeResponse.attributeTypeMap;
    }
}
PrescriptionV2NdcGetByCodeCodeGetByCodeResponse.discriminator = undefined;
PrescriptionV2NdcGetByCodeCodeGetByCodeResponse.additionalProperties = false;
PrescriptionV2NdcGetByCodeCodeGetByCodeResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PrescriptionNdcModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=prescriptionV2NdcGetByCodeCodeGetByCodeResponse.js.map